<template>
  <div>
    <form data-vv-scope="home"
          @submit.prevent="validarFormulario"
    >
      <b-row>
        <b-col md="4">
          <b-form-group label="Banner activo">
            <b-form-radio-group id="banner"
                                v-model="empresa.banner"
                                :options="opciones"
                                buttons
                                :button-variant="empresa.banner ? 'outline-primary' : 'outline-secondary'"
                                name="control_accesos"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Texto botón">
            <b-form-input id="boton_banner"
                          name="boton_banner"
                          data-vv-as=" "
                          :disabled="!empresa.banner"
                          v-validate="{rules: {required: !!empresa.banner, min: 5, max: 50}}"
                          v-model="empresa.boton_banner"
            />
            <div class="text-danger span-error small"
                 v-text="errors.first('home.boton_banner')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <hr>
          <b-button @click="backRoute()"
                    size="sm"
                    variant="secondary"
                    class="float-left"
          >
            <i class="fa fa-reply fa-lg"></i>
            Volver
          </b-button>

          <b-button v-if="validarPermisoComponente('empresa-editar-home')" @click.prevent="validarFormulario"
                    variant="primary"
                    class="btn-sm"
          >
            <i class="fa fa-save"/>
            Guardar
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>


import { mapActions, mapState, mapMutations } from 'vuex';
import {actualizarConfiguracionBanner} from '../../../servicios/empresa/home/actions';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: 'Home',
  data() {
    return {
      opciones: [
        {text: 'Si', value: 1},
        {text: 'No', value: 0},
      ],
      validarPermisoComponente: validarPermisoComponente
    };
  },
  computed: {
    ...mapState('home', [
      'empresa'
    ])
  },
  async mounted() {
    await this.datosEmpresa(this.$route.params.id);
  },
  methods: {
    ...mapActions('home', ['actualizarConfiguracionBanner']),
    ...mapActions('empresa', ['datosEmpresa']),
    ...mapMutations('home', ['resetBannerEmpresa']),
    async validarFormulario() {
      await this.$validator.validateAll('home')
        .then(async result => {
          if (result) {
            await this.actualizarConfiguracionBanner();
          }
        });
    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
  },
};
</script>

<style scoped>

</style>
